import React from 'react';
import styles from './SummaryTableControls.module.scss';

export default function SummaryTableControls({ children }) {
  return <div className={styles.controls}>{children}</div>;
}
